import './App.css';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import FeaturedPlaces from './pages/FeaturedPlaces';
import PopularTours from './pages/PopularTours';
import AboutUs from './pages/AboutUs';
import LatestArticle from './pages/LatestArticle';
import ContactUs from './pages/Contact';
import Hotel from './pages/HotelList';
import HotelDetail from './pages/HotelDetail';
import Packages from './pages/Packages';
import Goa from './pages/Goa';
import Kerala from './pages/Kerala';
import Dubai from './pages/Dubai';
import Abudhabi from './pages/AbuDhabi';
import Rajasthan from './pages/Rajasthan';
import Himachal from './pages/Himachal';
import Uttarakhand from './pages/Uttarakhand';
import BookNow from './pages/BookNow';
import LearnMore from './pages/LearnMore';
import Footer from './pages/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from "./pages/TermsConditions";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/packages" element={<Packages />} />
        <Route path="/hotels" element={<Hotel />} />
         <Route path="/hotels/:id" element={<HotelDetail />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/goa" element={<Goa />} />
        <Route path="/kerala" element={<Kerala />} />
        <Route path="/dubai" element={<Dubai />} />
        <Route path="/abu" element={<Abudhabi />} />
        <Route path="/rajasthan" element={<Rajasthan />} />
        <Route path="/himachal" element={<Himachal />} />
        <Route path="/uttarakhand" element={<Uttarakhand />} />
        <Route path="/booknow" element={<BookNow />} />
        <Route path="/learnmore" element={<LearnMore />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />

        {/* Default route loads all sections like a single-page website */}
        <Route
          path="/"
          element={
            <>
              <Home />
              <FeaturedPlaces />
              <PopularTours />
              <AboutUs />
              <LatestArticle />
            </>
          }
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
